<ng-container *ngIf="name | checkIcon : variant | async as config">
  <ion-icon
    [name]="config.name"
    [src]="config.src"
    [style.font-size]="iconSize"
    [style.width]="iconSize"
    [style.height]="iconSize"
    [style.color]="color || null"
    class="getm-icon"
  ></ion-icon>
</ng-container>
